export const NotFoundPage = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-black">
      <h1 className="text-9xl font-bold text-white">404</h1>
    </div>
  )
}
